/* eslint-disable jira/filename-case */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	type BoundActions,
	type HookFunction,
	type Store,
} from '@atlassian/react-sweet-state';
import type { State, StateActions } from './types.tsx';

const initialState: State = {
	selectedCloudId: '',
	siteDomain: '',
};

const actions = {
	setSitePickerState:
		({ selectedCloudId, siteDomain }: { selectedCloudId?: string; siteDomain?: string }) =>
		({ setState, getState }: StateActions): void => {
			const currentState = getState();
			setState({
				...currentState,
				selectedCloudId: selectedCloudId || '',
				siteDomain: siteDomain || '',
			});
		},
};

type Actions = typeof actions;

const store: Store<
	State,
	{
		setSitePickerState: ({
			selectedCloudId,
			siteDomain,
		}: {
			selectedCloudId?: string;
			siteDomain?: string;
		}) => ({ setState, getState }: StateActions) => void;
	}
> = createStore<State, Actions>({
	name: 'issue.fields.site-picker',
	initialState,
	actions,
});

export const useSitePickerContext: HookFunction<
	State,
	BoundActions<
		State,
		{
			setSitePickerState: ({
				selectedCloudId,
				siteDomain,
			}: {
				selectedCloudId?: string;
				siteDomain?: string;
			}) => ({ setState, getState }: StateActions) => void;
		}
	>,
	void
> = createHook(store);
